module.exports = __webpack_public_path__ + "static/media/Argentina_Croatia.25f8f388.jpeg";